/* eslint-disable no-nested-ternary */
import { FC, useState } from 'react'
import { FaWallet, FaHandHoldingUsd } from 'react-icons/fa'
import { Button, Table } from 'shared'
import DashCards from 'shared/molecules/dashCards/DashCards'
import { useNavigate } from 'react-router'
import './wallet.scss'
import { ButtonToolbar } from 'rsuite'
import TransactionStatusCell from 'shared/molecules/table/cells/TransactionStatusCell'
import { DateTimeCell } from 'shared/molecules/table/cells'
import TransactionTypeCell from 'shared/molecules/table/cells/TransactionTypeCell'
import AmountCell from 'shared/molecules/table/cells/AmountCell'
import { Cell, Column, HeaderCell } from 'rsuite-table'
import Payment from '../payment/payment'
import {
  useFetchTransactionListQuery,
  useGetWalletCountQuery
} from '../walletApiSlice'
import { payment, wallet, WalletListRequest } from '../types'
import { useTableHandlers } from '../../../hooks/useTableHandlers'

const Walletcolumns = [
  { key: 'amount', label: 'Amount', width: 150 },
  { key: 'type', label: 'Transaction Type', width: 250 },
  { key: 'status', label: 'Status', width: 150 }
]

const Wallet: FC = () => {
  const navigate = useNavigate()
  const [showAmountModal, setShowAmountModal] = useState<boolean>(false)
  const { data: WalletData } = useGetWalletCountQuery() as { data?: payment }

  const { requestBody, onPageChange } = useTableHandlers<
    wallet,
    WalletListRequest
  >(
    {
      page: { size: 10, number: 1 }
    },
    'name'
  )

  const { data: TransactionData, isFetching } =
    useFetchTransactionListQuery(requestBody)
  const WALLET_DATA = [
    {
      title: 'Wallet Balance',
      description: WalletData?.totalBalance ?? 0,
      icon: <FaWallet className="dashboard-icon" />,
      route: '/templates'
    },
    {
      title: 'Spend Balance',
      description: WalletData?.spendBalance ?? 0,
      icon: <FaHandHoldingUsd className="dashboard-icon iconfailed" />,
      route: '/campaigns'
    }
  ]

  const showTransactionData = () => {
    navigate('/wallet/transaction')
  }

  const onclose = () => {
    setShowAmountModal(false)
  }
  const showAmount = () => {
    setShowAmountModal(true)
  }
  return (
    <div className="main-wallet-container">
      <DashCards data={WALLET_DATA} />
      <div className="wallet-container">
        <div className="wallet-btn">
          <ButtonToolbar>
            <Button className="history-btn" onClick={showTransactionData}>
              Payments & Billing
            </Button>
            <Button appearance="primary" onClick={() => showAmount()}>
              Add Money
            </Button>
          </ButtonToolbar>
        </div>

        <div>
          {TransactionData?.totalElements === 0 ? (
            <div className="Wallet-transaction-card-container">
              <div className="card-header">
                <h3>No Transaction Data Available</h3>
              </div>
              <p className="card-sub-header">
                Add your balance to the wallet and start the campaign.
              </p>
            </div>
          ) : (
            <div className="list__main-container">
              <Table
                data={TransactionData?.content || []}
                loading={isFetching}
                paginated
                pageSizeOptions={[10, 20, 30]}
                total={TransactionData?.totalElements}
                defaultPageSize={10}
                onPageChange={onPageChange}
              >
                <Column flexGrow={1}>
                  <HeaderCell>Date</HeaderCell>
                  <DateTimeCell
                    dataKey="createdDate"
                    format="dd/MMM/yy, h:mm a"
                  />
                </Column>
                {Walletcolumns.map(({ key, label }, index) => (
                  <Column
                    flexGrow={1}
                    key={key}
                    align={index === 0 ? 'left' : 'center'}
                    sortable
                  >
                    <HeaderCell>{label}</HeaderCell>
                    {key === 'status' ? (
                      <TransactionStatusCell dataKey={key} />
                    ) : key === 'type' ? (
                      <TransactionTypeCell dataKey={key} />
                    ) : key === 'amount' ? (
                      <AmountCell dataKey={key} />
                    ) : (
                      <Cell dataKey={key} />
                    )}
                  </Column>
                ))}
              </Table>
            </div>
          )}
        </div>
      </div>
      {showAmountModal && <Payment open={showAmountModal} onClose={onclose} />}
    </div>
  )
}
export default Wallet
